import {
  hCaptchaQueryKey,
  timeBeforeRefetchMS,
} from "@faire/deprecated-retailer-visitor-shared/lib/captchaUtils";
import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

import { useFetchHCaptchaData } from "./useFetchHCaptchaData";
import { useFetchWidgetID } from "./useFetchWidgetId";
import { usePrecheckSession } from "./usePrecheckSession";

/**
 * Prefetches hCaptcha token when widgetID is available and prefetches session trustworthyness.
 */
export const usePrefetchToken = () => {
  const { fetch: fetchPrecheckSession } = usePrecheckSession();
  const { fetchHCaptchaData } = useFetchHCaptchaData();
  const { widgetID } = useFetchWidgetID();
  const queryClient = useQueryClient();

  const prefetchToken = useCallback(async () => {
    const precheckSession = await fetchPrecheckSession();
    const isTrustworthy = precheckSession.isTrustworthy;

    if (widgetID && !isTrustworthy) {
      void queryClient.prefetchQuery({
        queryKey: hCaptchaQueryKey(widgetID),
        queryFn: () => fetchHCaptchaData(widgetID),
        staleTime: timeBeforeRefetchMS(),
        gcTime: timeBeforeRefetchMS(),
      });
    }
  }, [queryClient, widgetID, fetchHCaptchaData, fetchPrecheckSession]);

  return { prefetchToken };
};
